module.exports = __webpack_public_path__ + "img/1525813318.4b8e8d0b.jpg";